import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getDetailKBM } from "api/ApiPenghapusan";
import ilustrasiKbmAman from "assets/ilustrasi-kbm-aman.svg";
import ilustrasiKbmNunggak from "assets/ilustrasi-kbm-nunggak.svg";
import ilustrasiKbmDihapus from "assets/ilustrasi-kbm-dihapus-v2.svg";
import logo1 from "assets/logo1.png";
import logo2 from "assets/logo2.png";
import logo3 from "assets/logo3.png";
import "pages/Detail.css";
import DetailForm from "component/DetailForm";

function Detail() {
  let dataParams = useParams();
  const [detailKBM, setDetailKBM] = useState(null);

  useEffect(() => {
    getDetailKBM(dataParams).then((response) => {
      if (response?.data?.data) {
        setDetailKBM(response.data.data);
      }
    });
  }, [dataParams]);
  return (
    <>
      <div className="row wrapper">
        <div className="col-12 content">
          <DetailForm detailKBM={detailKBM} />
        </div>
        <div className="col-12 d-flex align-items-center footer">
          <div className="p-3 detail-img">
          {detailKBM?.flag_pajak === "1" && (
            <div>
              <img
                className="ilustration-img mt-4"
                src={ilustrasiKbmAman}
                alt="Langkah-langkah Penggunaan Sistem"
              />
            </div>
            )}
            {(detailKBM?.flag_pajak === "2" && detailKBM?.flag_stnk !== "3") && (
              <div>
              <img
                className="ilustration-img mt-4"
                src={ilustrasiKbmNunggak}
                alt="Langkah-langkah Penggunaan Sistem"
              />
            </div>
            )}
            {(detailKBM?.flag_pajak === "2" && detailKBM?.flag_stnk === "3") && (
              <div>
              <img
                className="ilustration-img mt-4"
                src={ilustrasiKbmDihapus}
                alt="Langkah-langkah Penggunaan Sistem"
              />
            </div>
            )}
          </div>

          <div className="p-3 sponsor">
            <p className="text-center m-0">Dipersembahkan oleh: </p>
            <div className="d-flex justify-content-center">
              <img className="p-2" src={logo2} alt="" />
              <img className="p-2" src={logo1} alt="" />
              <img className="p-2" src={logo3} alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Detail;
